import { render, staticRenderFns } from "./baseinfor-block.vue?vue&type=template&id=c8069dc8&"
import script from "./baseinfor-block.vue?vue&type=script&lang=js&"
export * from "./baseinfor-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports